import { createRoot } from "react-dom/client";
import * as kiwiSdk from "@huyafed/huya-kiwi";
import { tafFetch } from "@/api/_tafFetch";
import { GAME_ID, TOOL_ID } from "@/config/env";
import logger from "@/utils/logger";
import { CURRENT_ENV } from "@/utils/env";
import App from "./App";

const logRuntimeInitializationError = (error: unknown) => {
  const message = "[GameToolRuntime] initialization failed";
  try {
    logger.error(message, { error });
  } catch (loggerError) {
    console.warn("[GameToolRuntime] SDK logger failed:", loggerError);
  }
  console.warn(`${message}:`, error);
};

try {
  const runtimeInit = window.GameToolRuntime?.init({
    gameId: GAME_ID,
    toolId: TOOL_ID,
    env: CURRENT_ENV,
    tafFetch,
    sdk: kiwiSdk,
  });
  void runtimeInit?.catch(logRuntimeInitializationError);
} catch (error) {
  logRuntimeInitializationError(error);
}

// 桌面设备检测：仅当支持 hover 且主输入为精确指针时添加标记
// CSS 用 .has-hover 前缀门控所有 :hover 规则，触屏设备不添加此 class
if (window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
  document.documentElement.classList.add("has-hover");
}

createRoot(document.getElementById("root")!).render(<App />);
